import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { BuildInfo } from "@/components/BuildInfo";
import { Button } from "@/components/ui/button";
import { KeyRound, ArrowLeft, LifeBuoy } from "lucide-react";

/**
 * Recuperação de acesso. Sem envio de e-mail (fora de escopo), a página só ORIENTA — nunca confirma se um
 * e-mail existe nem qual provedor usa (anti-enumeração). Caminhos: (1) entrar com Google e criar uma senha
 * no perfil; (2) pedir ao administrador que libere a redefinição, concluída depois com identidade provada.
 */
export default function AccountRecovery() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md space-y-8">
          <Logo />
          <div className="space-y-2">
            <div className="inline-flex items-center gap-2 rounded-full border bg-secondary/40 px-3 py-1.5 text-xs font-medium text-muted-foreground">
              <KeyRound className="h-3.5 w-3.5" />
              Recuperar acesso
            </div>
            <h2 className="font-display text-3xl font-bold tracking-tight">Não consegue entrar?</h2>
            <p className="text-sm text-muted-foreground">
              Veja como recuperar o acesso à sua conta Naturexpress.
            </p>
          </div>

          <div className="space-y-4">
            <div className="surface-card p-5 space-y-2">
              <h3 className="font-display font-semibold text-sm">1. Entre com o Google</h3>
              <p className="text-sm text-muted-foreground">
                Se você já usou o botão <span className="font-medium text-foreground">Entrar com Google</span>,
                acesse por ele. Depois, em <span className="font-medium text-foreground">Minha ficha</span>, você
                pode criar uma senha e passar a entrar também por e-mail e senha.
              </p>
            </div>

            <div className="surface-card p-5 space-y-2">
              <h3 className="font-display font-semibold text-sm">2. Peça ajuda ao administrador</h3>
              <p className="text-sm text-muted-foreground">
                Se você acessa por senha e a esqueceu, fale com o administrador da sua conta e peça a
                liberação da redefinição. Por segurança, a nova senha só é definida depois de confirmarmos
                a sua identidade no acesso — nunca apenas informando o e-mail.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <Button asChild variant="hero" size="lg" className="w-full">
              <Link to="/login">
                <ArrowLeft className="h-4 w-4" /> Voltar para o login
              </Link>
            </Button>
            <p className="text-xs text-muted-foreground text-center inline-flex items-center justify-center gap-1.5">
              <LifeBuoy className="h-3.5 w-3.5" />
              Precisa de suporte? Fale com o administrador da sua conta.
            </p>
          </div>
        </div>
      </div>
      <footer className="py-4 px-6">
        <BuildInfo />
      </footer>
    </div>
  );
}
